import React from 'react';

interface NewDataSourceIconProps {
  className?: string;
}

const NewDataSourceIcon: React.FC<NewDataSourceIconProps> = ({ className = '' }) => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="#ccc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 8V16" stroke="#ccc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 12H16" stroke="#ccc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default NewDataSourceIcon;